import { useContext } from "react";
// my imports:
import { AnyGameObj } from "@/app/lib/game-state/game-types";
import UI from "@/app/lib/ui/ui";
import WordBox from "@/app/components/WordBox";
import { Contexts } from "@/app/components/Context";
// styles
import styles from "@/app/styles/gameBox.module.css"


export default function GameBox() {
    
    const activeGame: AnyGameObj | null = useContext(Contexts.ActiveGame);
    const ui: UI | null = useContext(Contexts.UI);

    if (!activeGame || !ui) {
        console.warn('bad context in GameBox')
        return;
    }

    return (
            <div
                
            >
                {activeGame.state.words.map((word) => 
                    <WordBox
                        key={word.index}
                        wordIndex={word.index}
                    />
                )}
            </div>
        )
}